import React from 'react'
import { Box, Drawer } from '@mui/material'
import ResizableSidePanelLayout from 'components/common/ResizableSidePanelLayout'
import { useCreateDraftConfiguredServiceContext } from './CreateDraftConfiguredServiceContext'
import { useCreateDraftServiceSelection } from './hooks/useCreateDraftServiceSelection'
import DraftServiceFooter from './components/DraftServiceFooter'
import DraftServiceFilterSidebar from './components/DraftServiceFilterSidebar'
import DraftServiceSelectionArea from './components/DraftServiceSelectionArea'

const FILTER_PANEL_MIN_SIZE = 15
const FILTER_PANEL_MIN_SIZE_OPEN = 35
const FILTER_PANEL_SIDE_PANEL_STYLE = { minWidth: 200 }

const CreateDraftServiceForm = () => {
  const {
    pricingServices,
    watch,
    dirtyFields,
    setValue,
    isDesktop,
    isFilterPanelOpen,
    filterPanelSizes,
    handleFilterPanelLayoutChange,
    isMobileFilterOpen,
    handleCloseMobileFilterPanel,
  } = useCreateDraftConfiguredServiceContext()

  useCreateDraftServiceSelection({ pricingServices, setValue, watch, dirtyFields })

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
      <Box sx={{ flex: 1, minHeight: 0, overflow: 'hidden', mt: 2 }}>
        {isDesktop ? (
          <ResizableSidePanelLayout
            showSidePanel={isFilterPanelOpen}
            sidePanelSize={filterPanelSizes.filterPanel}
            mainPanelSize={isFilterPanelOpen ? filterPanelSizes.servicesPanel : 100}
            minPanelSize={isFilterPanelOpen ? FILTER_PANEL_MIN_SIZE_OPEN : FILTER_PANEL_MIN_SIZE}
            sidePanelStyle={FILTER_PANEL_SIDE_PANEL_STYLE}
            onLayoutChange={handleFilterPanelLayoutChange}
            sidePanel={<DraftServiceFilterSidebar />}
            mainPanel={
              <Box sx={{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column', px: 2 }}>
                <DraftServiceSelectionArea />
              </Box>
            }
            style={{ height: '100%' }}
          />
        ) : (
          <>
            <Box sx={{ height: '100%', overflowY: 'auto', overflowX: 'hidden', px: 3 }}>
              <DraftServiceSelectionArea />
            </Box>
            <Drawer
              anchor="bottom"
              open={isMobileFilterOpen}
              onClose={handleCloseMobileFilterPanel}
              sx={{ zIndex: theme => theme.zIndex.modal + 10 }}
              PaperProps={{ sx: { height: '80vh', borderTopLeftRadius: 12, borderTopRightRadius: 12 } }}
            >
              <DraftServiceFilterSidebar onToggle={handleCloseMobileFilterPanel} disableOutline />
            </Drawer>
          </>
        )}
      </Box>
      <DraftServiceFooter />
    </Box>
  )
}

export default CreateDraftServiceForm
